// src/services/companyModuleService.js
import axios from 'axios';

const API_BASE = 'http://localhost:8080/webnet-hms/api/company-noti/';

export const CompanyNotiService = {
  // Sync modules for company (add missing entries)
  syncNotiForCompany: (companyId) => {
    return axios.post(`${API_BASE}company/${companyId}/sync/`);
  },

  // Update deleted flags based on company/module status
  updateDeletedFlags: (companyId) => {
    return axios.post(`${API_BASE}company/${companyId}/update-deleted/`);
    
  },

  // Fetch company modules by companyId
  getNotisByCompany: (companyId) => {
    return axios.get(`${API_BASE}company/${companyId}`);
   
  },

  // Update enable/disable status (toggle)
  updateCompanyNotiStatus: (companyNotiId, isActive) => {
    const deleted=false;
    try {
      const response = axios.put(`${API_BASE}${companyNotiId}`, {
        isActive,
        deleted
      });
      window.alert("updated successfully!");
      return response.data;
    } catch (error) {
      console.error("Error updating Company:", error);
      window.alert("Failed to update Company.");
    }
    
  },
};

export default CompanyNotiService;
